import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCalendarGraySmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={52} height={52} fill="none" {...props}>
      <rect width={36} height={36} x={8} y={8} fill="#fff" rx={8} />
      <path fill="#D7DEE8" d="M34.1 8h2.7v2.25a1.35 1.35 0 1 1-2.7 0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M34.1 8v2.25a1.35 1.35 0 1 0 2.7 0V8z"
        clipRule="evenodd"
      />
      <path
        fill="#9CA9BD"
        fillRule="evenodd"
        d="M17.9 10.25V8h16.2v2.25a1.35 1.35 0 1 0 2.7 0V8h4.5a2.7 2.7 0 0 1 2.7 2.7v4.5H8v-4.5A2.7 2.7 0 0 1 10.7 8h4.5v2.25a1.35 1.35 0 1 0 2.7 0m11.7-.45h-7.2a.9.9 0 1 0 0 1.8h7.2a.9.9 0 1 0 0-1.8"
        clipRule="evenodd"
      />
      <path
        fill="#7689A6"
        d="M22.4 9.8h7.2a.9.9 0 1 1 0 1.8h-7.2a.9.9 0 1 1 0-1.8m-1.8 17.1h3.6a.9.9 0 0 1 .9.9v3.6a.9.9 0 0 1-.9.9h-3.6a.9.9 0 0 1-.9-.9v-3.6a.9.9 0 0 1 .9-.9"
      />
      <path
        fill="#D7DEE8"
        fillRule="evenodd"
        d="M44 15.2H8v26.1a2.7 2.7 0 0 0 2.7 2.7h30.6a2.7 2.7 0 0 0 2.7-2.7zm-27.9 3.6h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9m8.1 0h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9m8.1 0h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9m8.1 0h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9m-24.3 8.1h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9m8.1 0h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9m8.1 0h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9m8.1 0h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9M16.1 35h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9m8.1 0h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9m8.1 0h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9m8.1 0h-3.6a.9.9 0 0 0-.9.9v3.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9"
        clipRule="evenodd"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={0.5}
        d="m23.84 28.7-1.886 1.776c-.038.035-.105.031-.137-.008l-.677-.837"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCalendarGraySmall);
export default ForwardRef;
